import { LpBadge, LpBanner, LpButton, LpDataTable, LpEmpty, LpIcon, LpTable, attr, html, } from "~/design-system";
const dailyBreakdownColumns = [
    {
        key: "dateData",
        label: "Period",
        group: "Overview",
        valueBinding: "dateData",
        width: 136,
        minWidth: 136,
        sticky: "start",
        sortable: true,
        required: true,
    },
    {
        key: "uniqueUsers",
        label: "FF",
        tooltipTitle: "Form Fills",
        description: "Count of form fills.",
        group: "Funnel",
        valueBinding: "$parent.formatNumeric(uniqueUsers)",
        width: 88,
        minWidth: 88,
        sortable: true,
        resizable: true,
        funnelOnly: true,
    },
    {
        key: "uniqueUsersConverted",
        label: "UUC",
        tooltipTitle: "Unique Users Converted",
        description: "Distinct users who generated a CPC or CPL revenue event.",
        group: "Funnel",
        valueBinding: "$parent.formatNumeric(uniqueUsersConverted)",
        width: 88,
        minWidth: 88,
        sortable: true,
        resizable: true,
        funnelOnly: true,
    },
    {
        key: "pctUniqueUsersConverted",
        label: "FF Monetized",
        description: "Percentage of form fills that generated a CPC or CPL revenue event.",
        group: "Funnel",
        valueBinding: "$parent.formatNumeric(pctUniqueUsersConverted, 2) + '%'",
        width: 116,
        minWidth: 116,
        sortable: true,
        resizable: true,
        funnelOnly: true,
    },
    {
        key: "clickouts",
        label: "ClickOuts",
        description: "Total carrier listing clicks from CPC events.",
        group: "ClickOuts",
        valueBinding: "$parent.formatNumeric(clickouts)",
        width: 104,
        minWidth: 104,
        sortable: true,
        resizable: true,
        funnelOnly: true,
    },
    {
        key: "clickoutsPerUser",
        label: "CO / UUC",
        description: "Average carrier clicks per unique user converted.",
        group: "ClickOuts",
        valueBinding: "$parent.formatNumeric(clickoutsPerUser, 2)",
        width: 104,
        minWidth: 104,
        sortable: true,
        resizable: true,
        visibleByDefault: false,
        funnelOnly: true,
    },
    {
        key: "pctFfClicked",
        label: "FF Clicked",
        description: "Percentage of form fills that clicked at least one carrier listing.",
        group: "ClickOuts",
        valueBinding: "$parent.formatNumeric(pctFfClicked, 2) + '%'",
        width: 108,
        minWidth: 108,
        sortable: true,
        resizable: true,
        visibleByDefault: false,
        funnelOnly: true,
    },
    {
        key: "leadsSold",
        label: "Leads Sold",
        description: "Number of times a user's lead information was purchased.",
        group: "Leads",
        valueBinding: "$parent.formatNumeric(leadsSold)",
        width: 108,
        minWidth: 108,
        sortable: true,
        resizable: true,
    },
    {
        key: "leadsPerUser",
        label: "Leads / UUC",
        description: "Average leads sold per unique user converted.",
        group: "Leads",
        valueBinding: "$parent.formatNumeric(leadsPerUser, 2)",
        width: 112,
        minWidth: 112,
        sortable: true,
        resizable: true,
        visibleByDefault: false,
    },
    {
        key: "pctFfWithLead",
        label: "FF with Lead",
        description: "Percentage of form fills whose lead information was purchased.",
        group: "Leads",
        valueBinding: "$parent.formatNumeric(pctFfWithLead, 2) + '%'",
        width: 116,
        minWidth: 116,
        sortable: true,
        resizable: true,
        visibleByDefault: false,
    },
    {
        key: "totalRevenue",
        label: "Total Revenue",
        description: "Sum of all CPC and CPL revenue.",
        group: "Revenue",
        valueBinding: "$parent.formatMoney(totalRevenue)",
        width: 120,
        minWidth: 120,
        sortable: true,
        resizable: true,
        funnelOnly: true,
    },
    {
        key: "thankYouRevenue",
        label: "TY Page Revenue",
        description: "ClickOut revenue generated from the thank-you page.",
        group: "Revenue",
        valueBinding: "$parent.formatMoney(thankYouRevenue)",
        width: 132,
        minWidth: 132,
        sortable: true,
        resizable: true,
        visibleByDefault: false,
        funnelOnly: true,
    },
    {
        key: "resultsRevenue",
        label: "Results Revenue",
        description: "ClickOut revenue generated from the results or listings page.",
        group: "Revenue",
        valueBinding: "$parent.formatMoney(resultsRevenue)",
        width: 132,
        minWidth: 132,
        sortable: true,
        resizable: true,
        visibleByDefault: false,
        funnelOnly: true,
    },
    {
        key: "clickoutRevenue",
        label: "ClickOut Revenue",
        description: "Total revenue from CPC carrier click events.",
        group: "Revenue",
        valueBinding: "$parent.formatMoney(clickoutRevenue)",
        width: 136,
        minWidth: 136,
        sortable: true,
        resizable: true,
        visibleByDefault: false,
        funnelOnly: true,
    },
    {
        key: "leadRevenue",
        label: "Lead Revenue",
        description: "Total revenue from CPL lead sale events.",
        group: "Revenue",
        valueBinding: "$parent.formatMoney(leadRevenue)",
        width: 120,
        minWidth: 120,
        sortable: true,
        resizable: true,
        visibleByDefault: false,
    },
    {
        key: "emailRetargetingRevenue1",
        label: "Email Retargeting 1",
        description: "Revenue where the UTM campaign is retargeting_1.",
        group: "Revenue",
        valueBinding: "$parent.formatMoney(emailRetargetingRevenue1)",
        width: 148,
        minWidth: 148,
        sortable: true,
        resizable: true,
        visibleByDefault: false,
        funnelOnly: true,
    },
    {
        key: "emailRetargetingRevenue2",
        label: "Email Retargeting 2",
        description: "Revenue where the UTM campaign is retargeting_2.",
        group: "Revenue",
        valueBinding: "$parent.formatMoney(emailRetargetingRevenue2)",
        width: 148,
        minWidth: 148,
        sortable: true,
        resizable: true,
        visibleByDefault: false,
        funnelOnly: true,
    },
    {
        key: "emailRetargetingRevenue3",
        label: "Email Retargeting 3",
        description: "Revenue where the UTM campaign is retargeting_3.",
        group: "Revenue",
        valueBinding: "$parent.formatMoney(emailRetargetingRevenue3)",
        width: 148,
        minWidth: 148,
        sortable: true,
        resizable: true,
        visibleByDefault: false,
        funnelOnly: true,
    },
    {
        key: "revenuePerUser",
        label: "RPUUC",
        description: "Total revenue divided by unique users converted.",
        group: "Unit economics",
        valueBinding: "$parent.formatMoney(revenuePerUser)",
        width: 96,
        minWidth: 96,
        sortable: true,
        resizable: true,
        funnelOnly: true,
    },
    {
        key: "clickRevenuePerUserConverted",
        label: "CRPUUC",
        description: "Click revenue divided by unique users converted.",
        group: "Unit economics",
        valueBinding: "$parent.formatMoney(clickRevenuePerUserConverted)",
        width: 96,
        minWidth: 96,
        sortable: true,
        resizable: true,
        visibleByDefault: false,
        funnelOnly: true,
    },
    {
        key: "revenuePerClickout",
        label: "RPCO",
        description: "ClickOut revenue divided by ClickOuts.",
        group: "Unit economics",
        valueBinding: "$parent.formatMoney(revenuePerClickout)",
        width: 88,
        minWidth: 88,
        sortable: true,
        resizable: true,
        visibleByDefault: false,
        funnelOnly: true,
    },
    {
        key: "revenuePerLead",
        label: "RPL",
        description: "Lead revenue divided by leads sold.",
        group: "Unit economics",
        valueBinding: "$parent.formatMoney(revenuePerLead, 2)",
        width: 80,
        minWidth: 80,
        sortable: true,
        resizable: true,
        visibleByDefault: false,
    },
].map((column) => {
    const headerBindings = [
        column.funnelOnly ? "visible: !hideFunnelMetrics()" : "",
        `attr: { 'aria-sort': orderBy() === '${column.key}' ? (orderByDirection() === 'ASC' ? 'ascending' : 'descending') : 'none' }`,
    ].filter(Boolean).join(", ");
    const sortBindings = [
        `click: onClickReorder.bind($data, '${column.key}')`,
        `attr: { 'data-direction': orderBy() === '${column.key}' ? (orderByDirection() === 'ASC' ? 'ascending' : 'descending') : 'none' }`,
    ].join(", ");
    return {
        ...column,
        visibleByDefault: true,
        headerAttributes: { "data-bind": headerBindings },
        sortAttributes: { "data-bind": sortBindings },
        menuAttributes: column.funnelOnly
            ? { "data-bind": "visible: !hideFunnelMetrics()" }
            : undefined,
        skeletonAttributes: column.funnelOnly
            ? { "data-bind": "visible: !hideFunnelMetrics()" }
            : undefined,
    };
});
export const revenueInsightsChartMetrics = dailyBreakdownColumns
    .filter((column) => column.key !== "dateData")
    .map((column) => ({
    key: column.key,
    label: String(column.label),
    group: column.group,
}));
function renderBodyCell(column) {
    return LpTable.Cell({
        column,
        attributes: {
            "data-bind": column.funnelOnly ? "visible: !$parent.hideFunnelMetrics()" : undefined,
        },
        children: html `
            <span class="lp-table_cell-content" data-bind="text: ${column.valueBinding}"></span>
        `,
    });
}
function renderFooterCell(column) {
    const valueBinding = column.key === "dateData" ? undefined : column.valueBinding;
    return LpTable.FootCell({
        column,
        attributes: {
            "data-bind": column.funnelOnly ? "visible: !$parent.hideFunnelMetrics()" : undefined,
        },
        children: html `
            <span
                class="lp-table_cell-content"
                ${attr("data-bind", valueBinding ? `text: ${valueBinding}` : undefined)}
            >${column.key === "dateData" ? "Total" : ""}</span>
        `,
    });
}
function renderTableBody() {
    return html `
        ${LpTable.Body({
        attributes: {
            "data-bind": "foreach: listData, visible: hasLoadedData() && requestState() !== 'loading'",
        },
        children: LpTable.Row({ children: dailyBreakdownColumns.map(renderBodyCell) }),
    })}
        ${LpTable.SkeletonBody({
        columns: dailyBreakdownColumns,
        rows: 10,
        label: "Loading revenue insights breakdown",
        attributes: {
            "data-bind": "visible: requestState() === 'loading'",
        },
    })}
        ${LpTable.StateBody({
        colSpan: dailyBreakdownColumns.length,
        attributes: {
            "data-bind": "visible: requestState() !== 'loading' && hasLoadedData() && listData().length === 0",
            style: "display: none;",
        },
        children: LpEmpty({
            title: "No matching data",
            description: "No data matches the selected filters.",
            icon: "magnifying-glass",
            size: "sm",
        }),
    })}
        ${LpTable.StateBody({
        colSpan: dailyBreakdownColumns.length,
        attributes: {
            "data-bind": "visible: requestState() === 'error' && !hasLoadedData()",
            style: "display: none;",
        },
        children: LpEmpty({
            title: "Unable to load revenue insights",
            description: html `<span data-bind="text: requestError"></span>`,
            icon: "warning-circle",
            contents: LpButton({
                label: "Try again",
                prefixIcon: "arrows-clockwise",
                variant: "primary",
                attributes: { "data-bind": "click: onRetryData" },
            }),
            size: "sm",
            attributes: { role: "alert" },
        }),
    })}
    `;
}
function renderTableFooter() {
    return html `
        ${LpTable.Footer({
        attributes: {
            "data-bind": "if: hasLoadedData() && requestState() !== 'loading' && totalsData().length > 0",
        },
        children: html `
                <!-- ko with: totalsData()[0] -->
                    ${LpTable.Row({
            className: "lp-table_footer-row",
            children: dailyBreakdownColumns.map(renderFooterCell),
        })}
                <!-- /ko -->
            `,
    })}
    `;
}
export function renderRevenueInsightsDailyBreakdown() {
    return LpDataTable({
        title: html `
            <span class="lp-data-table_layer-title-content">
                ${LpIcon({ name: "chart-line-up", size: 16, className: "lp-data-table_layer-title-icon" })}
                <span data-bind="text: breakdownTitle"></span>
                ${LpBadge({
            children: html `<span data-bind="text: lastRefreshedLabel"></span>`,
            variant: "primary",
            className: "insights-refresh-badge",
            attributes: {
                "data-bind": "visible: lastRefreshedLabel, attr: { title: lastRefreshedTitle }",
                style: "display: none;",
            },
        })}
            </span>
        `,
        caption: "Revenue Insights breakdown",
        columns: dailyBreakdownColumns,
        summary: html `
            <span
                data-bind="visible: hasLoadedData() && requestState() !== 'loading', text: breakdownCountLabel"
            ></span>
        `,
        actions: LpButton({
            label: "Export",
            prefixIcon: "download-simple",
            size: "sm",
            variant: "secondary",
            attributes: {
                "data-bind": "click: onExportData, disable: isExporting, attr: { 'aria-busy': isExporting() ? 'true' : null }",
            },
        }),
        notice: LpBanner({
            title: "Refresh failed",
            description: html `<span data-bind="text: requestError"></span>`,
            icon: "warning-circle",
            variant: "error",
            size: "sm",
            actions: LpButton({
                label: "Retry",
                prefixIcon: "arrows-clockwise",
                size: "sm",
                attributes: { "data-bind": "click: onRetryData" },
            }),
        }),
        noticeAttributes: {
            "data-bind": "visible: requestState() === 'error' && hasLoadedData()",
            style: "display: none;",
        },
        children: renderTableBody(),
        footer: renderTableFooter(),
    });
}
